import { api } from '@/lib/api';
import type { ShopListResponse, ShopProduct, ShopQuery } from './types';

function params(q: ShopQuery) {
  const p: Record<string, string | number> = {};
  if (q.category) p.category = q.category;
  if (q.q) p.q = q.q;
  if (q.species) p.species = q.species;
  if (q.page) p.page = q.page;
  if (q.page_size) p.page_size = q.page_size;
  return p;
}

export async function fetch_shop_food(q: ShopQuery = {}): Promise<ShopListResponse> {
  const res = await api.get<ShopListResponse>('/user/shop/food/products', { params: params(q) });
  return res.data;
}

export async function fetch_shop_pharmacy(q: ShopQuery = {}): Promise<ShopListResponse> {
  const res = await api.get<ShopListResponse>('/user/shop/pharmacy/products', { params: params(q) });
  return res.data;
}

/**
 * One product, for the detail page.
 *
 * The list endpoint is not reused with a filter: a detail page loaded from a link has no
 * list to filter, and paging through the shop to find one id is absurd.
 */
export async function fetch_shop_product(
  vertical: 'food' | 'pharmacy',
  id: string,
): Promise<ShopProduct> {
  const res = await api.get<ShopProduct>(`/user/shop/${vertical}/products/${id}`);
  return res.data;
}
